import { useMutation } from '@tanstack/react-query';
import type { BulkDestroyRequest } from '../types/CandidateProfile';

export default function useBulkDestroyCandidateProfiles() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async (params: BulkDestroyRequest) => {
      const response = await fetch('/agent/api/candidate_profiles/bulk_destroy', {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify(params),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || '削除に失敗しました');
      return data;
    },
  });
}
